import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5565214f"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "con" }
const _hoisted_2 = ["title"]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_van_skeleton = _resolveComponent("van-skeleton")!
  const _component_StaffItem = _resolveComponent("StaffItem")!
  const _component_van_list = _resolveComponent("van-list")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    (_openBlock(), _createElementBlock(_Fragment, null, _renderList(6, (i) => {
      return _createVNode(_component_van_skeleton, {
        title: "",
        avatar: "",
        row: 2,
        loading: _ctx.firstLoad,
        "avatar-shape": "square",
        "avatar-size": "100px",
        style: {"margin-top":"0.75rem"}
      }, null, 8, ["loading"])
    }), 64)),
    _createVNode(_component_van_list, {
      loading: _ctx.loading,
      "onUpdate:loading": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.loading) = $event)),
      finished: _ctx.finished,
      "finished-text": "没有更多了",
      error: _ctx.error,
      "onUpdate:error": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.error) = $event)),
      "error-text": "请求失败，点击重新加载",
      onLoad: _ctx.onLoad
    }, {
      default: _withCtx(() => [
        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.list, (item) => {
          return (_openBlock(), _createElementBlock("div", {
            key: item,
            title: item
          }, [
            _createVNode(_component_StaffItem, { staff: item }, null, 8, ["staff"])
          ], 8, _hoisted_2))
        }), 128))
      ]),
      _: 1
    }, 8, ["loading", "finished", "error", "onLoad"])
  ]))
}